import { render, staticRenderFns } from "./mainPageImage.vue?vue&type=template&id=f8f9bfee&"
import script from "./mainPageImage.vue?vue&type=script&lang=js&"
export * from "./mainPageImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports